<template>
  <div class="ivan-setting-page anCore-fill" v-loading="loading">
    <div class="row">
      <div class="form-group col-sm-4">
        <div class="input-group">
          <span class="input-group-addon"><span>项目类型</span></span>
          <select class="form-control" v-model="basicFilter" @change="resetPage">
            <option value="">全部</option>
            <option v-for="b in basicOptions" :key="b" :value="b">{{ b }}</option>
          </select>
        </div>
      </div>
      <div class="form-group col-sm-4 has-feedback">
        <div class="input-group">
          <span class="input-group-addon"><span>项目因子</span></span>
          <input class="form-control" v-model="keyWord" @input="resetPage">
          <span class="fa fa-search form-control-feedback" aria-hidden="true" />
          <span class="sr-only">-</span>
        </div>
      </div>
    </div>

    <div class="table-area">
      <table class="table table-bordered table-condensed">
        <thead>
          <tr>
            <th style="min-width:120px;">项目类型</th>
            <th style="min-width:88px;">项目因子</th>
            <th style="min-width:120px;">检测方法</th>
            <th style="min-width:120px;">分析费(化验费)</th>
            <th style="min-width:150px;">前处理费</th>
            <th style="min-width:150px;">采样费</th>
            <th style="min-width:150px;">总算项目单价</th>
            <th style="min-width:150px;">限制范围或说明</th>
            <th style="width:110px;text-align:center;">
              <button type="button" class="btn btn-success btn-sm" @click="onReadonly">
                <i class="fa fa-plus" />&nbsp;新增
              </button>
            </th>
          </tr>
        </thead>
        <tbody v-if="pageRows.length">
          <tr
            v-for="(row, idx) in pageRows"
            :key="row.FeeID || idx"
            :class="{ 'anCore-item-active': selectedId === (row.FeeID || idx) }"
            @click="selectRow(row.FeeID || idx)"
          >
            <td>
              <div>{{ row.InspectBasicTypeName }}</div>
              <div class="text-muted small">{{ row.InspectSubTypeNames }}</div>
            </td>
            <td>{{ row.ItemNames }}</td>
            <td>{{ (row.MethodAccord && row.MethodAccord.DisplayName) || '' }}</td>
            <td>{{ empty(row.AnalyseFee) }}</td>
            <td>{{ empty(row.BeforeDealFee) }}</td>
            <td>{{ empty(row.EntrustCollectFee) }}</td>
            <td>{{ empty(row.SubTotalFee) }}</td>
            <td>{{ row.Remark || '' }}</td>
            <td>
              <button type="button" class="btn btn-link btn-sm" title="编辑" @click.stop="onReadonly">
                <i class="fa fa-edit" />
              </button>
              <button type="button" class="btn btn-link btn-sm" title="删除" @click.stop="onReadonly">
                <i class="fa fa-trash-o text-muted" />
              </button>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="9">
              <div class="text-center text-muted" style="padding:10px 0;">当前暂无数据</div>
            </td>
          </tr>
        </tbody>
      </table>
      <ivan-pager :page-index.sync="pageIndex" :page-count="pageCount" @change="selectedId = null" />
    </div>
  </div>
</template>

<script>
import { loadIvanSyncJson } from '@/utils/ivanSync'
import ivanSettingList from '@/mixins/ivanSettingList'
import IvanPager from '@/components/ivan/IvanPager.vue'

const PAGE_SIZE = 15

export default {
  name: 'MonitorFeeSetting',
  components: { IvanPager },
  mixins: [ivanSettingList],
  data() {
    return {
      loading: false,
      list: [],
      basicOptions: [],
      basicFilter: '',
      keyWord: ''
    }
  },
  computed: {
    filtered() {
      const kw = String(this.keyWord || '').trim().toLowerCase()
      return this.list.filter(row => {
        if (this.basicFilter && row.InspectBasicTypeName !== this.basicFilter) return false
        if (!kw) return true
        const hay = `${row.ItemNames || ''} ${row.InspectBasicTypeName || ''} ${row.InspectSubTypeNames || ''}`.toLowerCase()
        return hay.indexOf(kw) >= 0
      })
    },
    pageCount() {
      return this.calcPageCount(this.filtered.length, PAGE_SIZE)
    },
    pageRows() {
      return this.pageSlice(this.filtered, PAGE_SIZE)
    }
  },
  created() {
    this.load()
  },
  methods: {
    empty(v) {
      return v == null ? '' : v
    },
    async load() {
      this.loading = true
      try {
        const data = await loadIvanSyncJson('monitor_fee.json')
        this.list = (data && data.dataGrid && data.dataGrid.List) || []
        this.basicOptions = (data.basicTypeList || []).map(b => b.InspectBasicType).filter(Boolean)
      } catch (e) {
        this.$message.error(e.message || '加载监测费用失败')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.ivan-setting-page {
  height: 100%;
  padding: 8px 12px 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.ivan-setting-page > .row { margin: 0; flex: 0 0 auto; }
.table-area {
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
  height: calc(100% - 60px);
}
.table-area >>> tbody tr { cursor: pointer; }
.has-feedback .form-control-feedback {
  pointer-events: none;
  z-index: 3;
  right: 0;
  line-height: 34px;
  height: 34px;
}
</style>
